import { render, staticRenderFns } from "./footer-bottom.vue?vue&type=template&id=c256053c&scoped=true&lang=pug&"
import script from "./footer-bottom.vue?vue&type=script&lang=coffee&"
export * from "./footer-bottom.vue?vue&type=script&lang=coffee&"
import style0 from "./footer-bottom.vue?vue&type=style&index=0&id=c256053c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c256053c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SmartLink: require('/opt/build/repo/nuxt-app/components/globals/smart-link.coffee').default})
